import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Field, Input } from "@hulahoop/ui";
import type { InvestorWizardFormData } from "@/domain/validation/investorSchemas";

type TextFieldName = {
  [K in keyof InvestorWizardFormData]: InvestorWizardFormData[K] extends string | undefined
    ? K
    : never;
}[keyof InvestorWizardFormData];

export function WizardTextField({
  name,
  label,
  placeholder,
  required,
  deps,
}: {
  name: TextFieldName;
  label: string;
  placeholder?: string;
  required?: boolean;
  deps?: TextFieldName[];
}) {
  const { t } = useTranslation();
  const { register, formState } = useFormContext<InvestorWizardFormData>();
  const error = formState.errors[name]?.message;
  return (
    <Field
      label={t(label)}
      required={required}
      error={typeof error === "string" ? error : undefined}
    >
      <Input placeholder={placeholder && t(placeholder)} {...register(name, { deps })} />
    </Field>
  );
}
